import { render, staticRenderFns } from "./rule-settings.vue?vue&type=template&id=5b3c00ec&scoped=true&"
import script from "./rule-settings.vue?vue&type=script&lang=ts&"
export * from "./rule-settings.vue?vue&type=script&lang=ts&"
import style0 from "./rule-settings.vue?vue&type=style&index=0&id=5b3c00ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c00ec",
  null
  
)

export default component.exports